import React from 'react';
import '../css/LegalPages.css';

const FAQ = () => {
  return (
    <div className="legal-container">
      <h1>Sıkça Sorulan Sorular (SSS)</h1>

      {/* GENEL BİLGİLER */}
      <section>
        <h3>1. Halısahacım nedir?</h3>
        <p>
          Halısahacım, Türkiye genelindeki halı saha işletmelerini kullanıcılarla buluşturan bir
          dijital platformdur. Kullanıcılar kolayca saha arayabilir, müsait saatlere göre online
          rezervasyon oluşturabilir ve işletmelerle iletişim kurabilir. İşletmeler ise panel
          üzerinden tüm rezervasyon süreçlerini yönetebilir, hesaplarını aktif ederek tanıtım
          görünürlüğü kazanabilir.
        </p>
      </section>

      {/* KULLANICI SİSTEMİ */}
      <section>
        <h3>2. Halısaha arama işlemi nasıl yapılır?</h3>
        <p>
          Anasayfadaki “Halısahalar” bölümünden şehrinizi seçerek o şehirdeki tüm işletmelere
          ulaşabilirsiniz. Şehir seçimi sonrası işletme listesi, fotoğraflar, fiyat bilgisi, saha
          özellikleri ve müsait saatler görüntülenir.
        </p>
      </section>

      <section>
        <h3>3. Rezervasyon nasıl yapılır?</h3>
        <p>
          Bir işletmenin sayfasına girdikten sonra “Müsait Saatler” tablosundan uygun bir saat
          seçilir. Rezervasyon oluşturmak için kullanıcı girişi yapılması gerekir. Rezervasyon
          oluşturduktan sonra işletme paneline düşer ve işletme tarafından onaylanır.
        </p>
      </section>

      <section>
        <h3>4. Rezervasyonum iptal olursa ne olur?</h3>
        <p>
          İptal işlemleri tamamen işletmenin sorumluluğundadır. Kullanıcı ve işletme arasındaki tüm
          süreç Halısahacım sistemi üzerinden kayıt altına alınır ancak taraflar arasındaki iptal
          koşulları işletmenin politikalarına bağlıdır.
        </p>
      </section>

      {/* OYUNCU — RAKİP — TAKIM BULMA */}
      <section>
        <h3>5. Oyuncu, rakip veya takım bulma sistemi nasıl çalışır?</h3>
        <p>
          Platformda üç farklı kategori vardır:
        </p>
        <ul>
          <li><strong>Rakip Bul:</strong> Maç yapmak isteyen takımlar rakip arayabilir.</li>
          <li><strong>Oyuncu Bul:</strong> Eksik oyuncu arayan takımlar ilan verebilir.</li>
          <li><strong>Takım Bul:</strong> Bireysel kullanıcılar takım aramak için ilan oluşturabilir.</li>
        </ul>
        <p>
          Tüm ilanlar anasayfadaki ilgili kategorilerde görünür ve mesajlaşma sistemi üzerinden
          iletişim sağlanır.
        </p>
      </section>

      {/* MAÇ VİDEOLARI */}
      <section>
        <h3>6. Maç videoları kısmı nasıl çalışır?</h3>
        <p>
          Halısahacım’ın sunmuş olduğu video kayıt sistemi ile işletmeler otomatik olarak maç
          kayıtlarını platforma yükleyebilir. Kullanıcılar şehir ve işletme seçerek geçmiş maç
          videolarını görüntüleyebilir. Giriş yapan kullanıcılar video üzerinde klip kesme özelliğini
          kullanarak kendi önemli anlarını indirebilir.
        </p>
      </section>

      {/* EN İYİ GOLLER — TOPLULUK */}
      <section>
        <h3>7. En İyi Goller bölümü nedir?</h3>
        <p>
          Kullanıcılar kendi kliplerini yükleyebilir, topluluk tarafından paylaşılan en iyi golleri
          izleyebilir. Bu bölüm tamamen topluluk odaklıdır ve moderasyon sistemi ile yönetilir.
        </p>
      </section>

      {/* MESAJLAŞMA */}
      <section>
        <h3>8. Mesajlaşma sistemi nasıl çalışır?</h3>
        <p>
          Kullanıcılar ve işletmeler arasında gerçek zamanlı sohbet sistemi bulunmaktadır.
          Rezervasyon, oyuncu bulma ve video talepleri gibi tüm işlemler sohbet içinden hızlıca
          yapılabilir. Okunmamış mesaj sayısı hem web hem mobil görünümde bildirim olarak gösterilir.
        </p>
      </section>

      {/* İŞLETMELER — KURUMSAL */}
      <section>
        <h3>9. İşletmemi Halısahacım'a nasıl ekleyebilirim?</h3>
        <p>
          “İşletme Kayıt” bölümünden işletme bilgilerini doldurarak başvuru oluşturabilirsiniz.
          Başvurunuz incelendikten sonra hesabınız aktif hale gelir. 4K Kamera sistemini de 
          istiyorsanız kayıt olmadan önce bizimle iletişime geçin.
        </p>
      </section>

      <section>
        <h3>10. İşletme panelinde neler yapabilirim?</h3>
        <p>İşletmeler aşağıdaki özellikleri kullanabilir:</p>
        <ul>
          <li>Saha bilgilerini düzenleme</li>
          <li>Müsait saat ekleme – çıkarma</li>
          <li>Rezervasyon yönetimi</li>
          <li>Kullanıcılarla mesajlaşma</li>
          <li>Maç kayıtlarının görüntülenmesi</li>
          <li>Profil bilgisi, fotoğraf ve fiyat düzenleme</li>
          <li>Abonelik ve ödeme takibi</li>
        </ul>
      </section>

      {/* ÖDEME SİSTEMİ */}
      <section>
        <h3>11. Ödeme sistemi nasıl çalışıyor?</h3>
        <p>
          İşletmelerin üyelik ücretleri güvenli <strong>İyzico</strong> altyapısı üzerinden alınır.
          Ödeme tamamlandığında işletme hesabı anında aktif edilir. Ödemeler tamamen güvenli olup
          Halısahacım kullanıcı kart bilgilerini hiçbir şekilde saklamaz.
        </p>
      </section>

      {/* GÜVENLİK */}
      <section>
        <h3>12. Verilerim güvende mi?</h3>
        <p>
          Platformdaki tüm veri akışları SSL ile şifrelenmiştir. Kişisel veriler KVKK
          mevzuatına uygun şekilde saklanır ve üçüncü taraflarla ticari amaçla paylaşılmaz.
          Detaylar için KVKK Aydınlatma Metni'ni inceleyebilirsiniz.
        </p>
      </section>

      {/* HESAP VE PROFİL */}
      <section>
        <h3>13. Hesabımı nasıl silebilirim?</h3>
        <p>
          Kullanıcı veya işletme hesabınızı profil ayarları bölümünden talep oluşturarak
          silebilirsiniz. Hesabınız silindiğinde tüm verileriniz 6698 sayılı KVKK’ya uygun
          şekilde sistemden kaldırılır.
        </p>
      </section>

      {/* ŞİFRE / GÜVENLİK */}
      <section>
        <h3>14. Şifremi unuttum, ne yapmalıyım?</h3>
        <p>
          “Şifre Sıfırlama” sayfasından e-posta adresinizi girerek yeni şifre oluşturabilirsiniz.
          Hem kullanıcı hem işletme için ayrı şifre sıfırlama ekranları bulunmaktadır.
        </p>
      </section>

      {/* TEKNİK DESTEK */}
      <section>
        <h3>15. Destek almak için nereye başvurabilirim?</h3>
        <p>
          Tüm talep ve teknik destek ihtiyaçlarınız için:
        </p>
        <p>
          📧 <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a>
        </p>
        <p>
          Destek ekibimiz en geç 24 saat içinde dönüş sağlar.
        </p>
      </section>
    </div>
  );
};

export default FAQ;
